// @ts-ignore
import editIcon from "../../img/edit.png";
// @ts-ignore
import deleteIcon from "../../img/delete.png";
import {useContext, useEffect, useState} from "react";
import {CourseTypeDTO} from "../model/CourseTypeDTO";
import {LocationDTO} from "../model/LocationDTO";
// @ts-ignore
import {APIContext} from "../Globals.tsx";
import InputColor from 'react-input-color';
import TextInputWeex from "../elements/TextInputWeex";
import NumberInputWeex from "../elements/NumberInputWeex";
// @ts-ignore
import Defaults from "../Defaults.tsx";
import SelectWeex from "../elements/SelectWeex";
import {TagDTO} from "../model/TagDTO";
// @ts-ignore
import {Modal} from "../Modal.tsx";
// @ts-ignore
import {SettingsCard} from "./SettingCard.tsx";

export default function CourseRooms(){
  const [courseTypes, setCourseTypes] = useState<CourseTypeDTO[]>([]);
  const [locations, setLocations] = useState<LocationDTO[]>([]);
  const [courseTypeInput, setCourseTypeInput] = useState<CourseTypeDTO>({});
  const [locationInput, setLocationInput] = useState<LocationDTO>({});
  const [addNewCourseType, setAddNewCourseType] = useState(false);
  const [addNewLocation, setAddNewLocation] = useState(false);
  const [favoriteTags, setFavoriteTags] = useState<TagDTO[]>();
  const [allTags, setAllTags] = useState<TagDTO[]>();
  const {
    fetchCourseTypes, fetchLocations, pushLocation, pushCourseType, getTags, saveTags, deleteCourseType
  } = useContext(APIContext);

  useEffect(() => {
    fetchLocations().then((res) => {
      setLocations(res?.locations ?? []);
    });
    fetchCourseTypes().then((res) => {
      setCourseTypes(res?.types ?? []);
    });
    getTags().then((res) => {
      const tags = res?.tags?.map((tag) => {
        return {
          label: tag.name, value: tag.id, ...tag
        };
      })
      setAllTags(tags)
      setFavoriteTags(tags.filter((tag) => tag.favorite))
    });
  }, []);

  useEffect(() => {
    if(!addNewLocation) setLocationInput({})
  }, [addNewLocation])

  useEffect(() => {
    if(!addNewCourseType) setCourseTypeInput({})
  }, [addNewCourseType])

  function renderCourseType(courseType: CourseTypeDTO){
    return <SettingsCard
      onEdit={() => {
        setCourseTypeInput(courseType);
        setAddNewCourseType(true);
      }}
      onDelete={() => {
        deleteCourseType(courseType).then(r => r && window.location.reload())
      }}>
      <h4>{courseType.name}</h4>
      <p>{courseType.short}</p>
      <div style={{
        width: "20px",
        height: "20px",
        backgroundColor: courseType.color,
        border: "1px solid #000",
        display: "inline-block",
        marginRight: "5px"
      }}/>
      <br/>
      <Defaults onSave={(e) => {
        pushCourseType(e).then(() => window.location.reload())
      }} defaults={courseType} setCourseType={(data: CourseTypeDTO) => setCourseTypes(types => types.map((type) => {
        if(type.id == data.id) return data; else return type
      }))}/>
    </SettingsCard>
  }

  function renderCourseTypeInput(){
    return <Modal
      actionP={() => pushCourseType(courseTypeInput).then((e) => e && window.location.reload())}
      actionS={() => setAddNewCourseType(false)}
      buttonS={"Schließen"}
      buttonP={"Speichern"}
      valid={courseTypeInput?.name && courseTypeInput?.short && courseTypeInput?.color}>
      <TextInputWeex placeholder={"Bezeichnung"} value={courseTypeInput.name ?? ""} onChange={(e) => {
        setCourseTypeInput({...courseTypeInput, name: e.target.value});
      }} label={"Bezeichnung"} light={true}/>
      <TextInputWeex placeholder={"Kurzbezeichnung"} value={courseTypeInput.short ?? ""} onChange={(e) => {
        setCourseTypeInput({...courseTypeInput, short: e.target.value});
      }} label={"Kurzbezeichnung"} light={true}/>
      <InputColor
        initialValue={courseTypeInput.color ?? ""}
        onChange={(e) => {
          if(!e.hex.includes("NaN")) setCourseTypeInput({...courseTypeInput, color: e.hex});
        }}
        placement="right"/>
    </Modal>
  }

  function renderLocation(location: LocationDTO){
    return <SettingsCard onEdit={() => {
      setLocationInput(location);
      setAddNewLocation(true);
    }} onDelete={null}>
      <h4>{location.name}</h4>
      <label>Kapazität:</label><p>{location.capacity}</p>
    </SettingsCard>
  }

  function renderLocationInput(){
    return <Modal
      actionP={() => pushLocation(locationInput).then((e) => e && window.location.reload())}
      actionS={() => setAddNewLocation(false)}
      buttonS={"Schließen"}
      buttonP={"Speichern"}
      valid={locationInput?.name && locationInput?.capacity}>
      <TextInputWeex placeholder={"Name"} value={locationInput.name ?? ""} onChange={(e) => {
        setLocationInput({...locationInput, name: e.target.value});
      }} label={"Name"} light={true}/>
      <NumberInputWeex value={locationInput.capacity ?? 0} onChange={(e) => {
        setLocationInput({...locationInput, capacity: e});
      }} placeholder={"Teilnehmer"} label={"Kapazität"} light={true}/>
    </Modal>
  }

  return (<div style={{position: "relative", width: "100%", height: "100%"}}>
    {addNewLocation && renderLocationInput()}
    {addNewCourseType && renderCourseTypeInput()}
    <h3>Tag Favoriten</h3>
    <SelectWeex placeholder={"Suche nach Tag..."} value={favoriteTags} options={allTags}
                style={{marginBottom: 2}}
                onChange={(e) => {
                  setAllTags(all => all.map(tag => {
                    return {
                      ...tag, favorite: !!e.find(tag_ => tag.id === tag_.id)
                    };
                  }))
                  setFavoriteTags(e)
                }} isMulti={true}/>
    <button className={"primarybutton"} onClick={() => {
      saveTags({tags: allTags}).then(() => window.location.reload())
    }}>Speichern
    </button>
    <h3>KurseTypes und Standardwerte</h3>
    <button className={"primarybutton"} onClick={() => setAddNewCourseType(true)}>Neuer Kurs</button>
    <br/>
    <div id={"course_types"} className={"news-container"}>
      {courseTypes.map((courseType) => renderCourseType(courseType))}
    </div>
    <h3>Räume</h3>
    <button className={"primarybutton"} onClick={() => setAddNewLocation(true)}>Neuer Raum</button>
    <br/>
    <div id={"rooms"} className={"news-container"}>
      {locations.map((location) => renderLocation(location))}
    </div>
    <br/>
  </div>);
}
